import { ContentTypeName } from '../../types/content.types.js'
import { accordion } from './accordion.js'
import { blog } from './blog.js'
import { bullets } from './bullets.js'
import { button } from './button.js'
import { calendar } from './calendar.js'
import { contactform } from './contactform.js'
import { document } from './document.js'
import { form } from './form.js'
import { gallery } from './gallery.js'
import { grid } from './grid.js'
import { header } from './header.js'
import { image } from './image.js'
import { imageCards } from './imageCards.js'
import { imageCollage } from './imageCollage.js'
import { logoSection } from './logoSection.js'
import { quicklinks } from './quicklinks.js'
import { richtext } from './richtext.js'
import { serviceCard } from './serviceCard.js'
import { sponsors } from './sponsors.js'
import { tipsbox } from './tipsbox.js'
import { topsection } from './topsection.js'
import { videoHero } from './videoHero.js'
import { ytvideo } from './ytvideo.js'
import { dSolutionsBadge } from './dSolutionsBadge.js'
import { foodMenu } from './foodMenu.js'
import { openingHours } from './openingHours.js'

export const dynamicContentTypes = [
  grid,
  header,
  richtext,
  button,
  image,
  blog,
  sponsors,
  calendar,
  contactform,
  quicklinks,
  accordion,
  tipsbox,
  document,
  ytvideo,
  imageCards,
  bullets,
  imageCollage,
  logoSection,
  serviceCard,
  gallery,
  form,
  dSolutionsBadge,
  foodMenu,
  openingHours,
]

export const staticContentTypes = [topsection, videoHero]

export const DYNAMIC_CONTENT_TYPES_WITHOUT_GRID = dynamicContentTypes.filter(
  (ct) => ct.name !== 'grid'
)

export const GRID_CONTENT_NAME: ContentTypeName = 'grid'

export const DYNAMIC_CONTENT_TYPE_NAMES =
  DYNAMIC_CONTENT_TYPES_WITHOUT_GRID.map((ct) => ct.name)

export const STATIC_CONTENT_TYPE_NAMES = staticContentTypes.map((ct) => ct.name)

export const TOP_LEVEL_CONTENT_TYPE_NAMES = [
  ...STATIC_CONTENT_TYPE_NAMES,
  GRID_CONTENT_NAME,
]
